import React from 'react';
import './ExtraEntries.css';

function ExtraEntries() {
  return (
    <div className="extra-entries-section">
      <h2 className="section-title">How to Get Extra Giveaway Entries</h2>
      
      <div className="entries-grid">
        <div className="entry-method">
          <div className="method-icon">🎯</div>
          <h3>Participate in Multiple Giveaways</h3>
          <p>Enter 5 giveaways consecutively → receive <strong>3x entries</strong> on your next giveaway.</p>
        </div>

        <div className="entry-method">
          <div className="method-icon">⚡</div>
          <h3>Boosts</h3>
          <ul>
            <li><strong>Boost 1:</strong> Doubles your entries (2x) for all giveaways during <strong>7 days</strong>.</li>
            <li><strong>Boost 2:</strong> Quadruples your entries (4x) for all giveaways during <strong>14 days</strong>.</li>
          </ul>
          <p>Boosts can be purchased, earned, or activated through special actions.</p>
        </div>

        <div className="entry-method">
          <div className="method-icon">💰</div>
          <h3>Monetary Contributions</h3>
          <ul>
            <li><strong>PayPal or iDEAL:</strong> Every set amount contributes to extra entries (e.g., <strong>1€ = 1 entry</strong>).</li>
            <li><strong>Gift cards or Discord Nitro:</strong> Assign entry value per item (e.g., <strong>$5 gift card = 3 entries</strong>).</li>
          </ul>
        </div>

        <div className="entry-method">
          <div className="method-icon">📱</div>
          <h3>Social or Community Actions</h3>
          <ul>
            <li>Sharing the giveaway link on social media = <strong>extra entries</strong>.</li>
            <li>Inviting friends to join the server = <strong>extra entries per confirmed join</strong>.</li>
            <li>Participating in special community events or challenges = <strong>extra entries</strong>.</li>
          </ul>
        </div>

        <div className="entry-method">
          <div className="method-icon">⭐</div>
          <h3>Loyalty / Activity Bonuses</h3>
          <ul>
            <li>Active participation in server events or chats may earn <strong>bonus entries</strong>.</li>
            <li>Completing weekly or monthly tasks can grant <strong>additional entries</strong>.</li>
          </ul>
        </div>

        <div className="entry-method">
          <div className="method-icon">🎁</div>
          <h3>Special Promotions</h3>
          <p>Occasionally, limited-time promotions can give <strong>bonus entries per giveaway</strong>.</p>
        </div>
      </div>
    </div>
  );
}

export default ExtraEntries;

